import { Observable } from 'rxjs';
import { environment } from '../../config';
import { useSubscription } from '../hooks/useSubscription';
import { BusEvent } from './EditorContext';

const useBusLogging = (bus$: Observable<BusEvent>) => {
  useSubscription(
    () => (environment === 'development' ? bus$.subscribe(console.log) : undefined),
    [bus$]
  );
};

export default useBusLogging;
